import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { withMediaSipContext } from '../../contexts/MediaSipContext';
import { styled } from '@mui/material/styles';
import * as sessionStates from '../../sessionStates';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

const Container = styled('div')({
	position: 'fixed',
	top: 0,
	right: 0,
	bottom: 0,
	padding: 20,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'flex-end',
	alignItems: 'flex-end',
	transition: 'right 0.3s'
});

const CardStyled = styled(Card)({
	width: 300,
	marginTop: 5
});

const SessionNotifications = (props) =>
{
	const { sipCaller } = props;

	const sessions = useSelector(state => state.sessions);
	const incomingSessions = Object.values(sessions).filter(session =>
		((session.sessionState === sessionStates.NEW ||
		  session.sessionState === sessionStates.ESTABLISHING) &&
		 session.direction === sessionStates.INCOMING));

	return (
		<Container>
			{ incomingSessions.map((session) =>
			{
				return (
					<CardStyled key={session.sipSession.request.callId}>
						<CardActionArea>
							<CardContent>
								<Typography gutterBottom variant='h6' component='h2'>
									Incoming call
								</Typography>
								<Typography component='p' noWrap>
									{ session.sipSession?.remoteIdentity?.displayName ||
										session.sipSession?.remoteIdentity?.uri.user }
								</Typography>
							</CardContent>
						</CardActionArea>
						<CardActions>
							<Button
								size='small'
								variant='contained'
								color='primary'
								onClick={() => sipCaller.accept(session.sipSession)}
							>
								Answer
							</Button>
							<Button
								size='small'
								color='error'
								onClick={() => sipCaller.terminate(session.sipSession)}
							>
								Decline
							</Button>
						</CardActions>
					</CardStyled>
				);
			})}
		</Container>
	);
};

SessionNotifications.propTypes = {
	sipCaller : PropTypes.object.isRequired
};

export default withMediaSipContext(SessionNotifications);